module.exports = __webpack_public_path__ + "img/avatar-1.67e2b9d7.jpg";